/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { useDispatch } from 'react-redux'
import { makeLogout } from '../../core/actions/authActions'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const DropdownComponent = () => {

    const dispatch = useDispatch();

    const handleLogout = (e) => {
        e.preventDefault();
        dispatch(makeLogout());
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button>
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9996 0.930664C6.34432 0.930664 0.930664 6.34432 0.930664 12.9996C0.930664 19.6549 6.34432 25.0686 12.9996 25.0686C19.6549 25.0686 25.0686 19.6549 25.0686 12.9996C25.0686 6.34432 19.6549 0.930664 12.9996 0.930664ZM7.20653 14.9307C6.94937 14.9365 6.69365 14.8909 6.45436 14.7965C6.21508 14.7021 5.99707 14.5609 5.81312 14.3811C5.62917 14.2013 5.48299 13.9866 5.38317 13.7495C5.28335 13.5124 5.2319 13.2578 5.23184 13.0006C5.23177 12.7434 5.2831 12.4887 5.3828 12.2516C5.4825 12.0145 5.62857 11.7997 5.81243 11.6198C5.99629 11.44 6.21423 11.2986 6.45347 11.2041C6.6927 11.1096 6.9484 11.0639 7.20556 11.0696C7.7101 11.0807 8.19023 11.2889 8.54316 11.6497C8.89609 12.0104 9.09378 12.495 9.0939 12.9996C9.09403 13.5043 8.89659 13.989 8.54384 14.3499C8.19108 14.7108 7.71106 14.9193 7.20653 14.9307ZM12.9996 14.9307C12.7425 14.9365 12.4867 14.8909 12.2475 14.7965C12.0082 14.7021 11.7902 14.5609 11.6062 14.3811C11.4223 14.2013 11.2761 13.9866 11.1763 13.7495C11.0765 13.5124 11.025 13.2578 11.0249 13.0006C11.0249 12.7434 11.0762 12.4887 11.1759 12.2516C11.2756 12.0145 11.4217 11.7997 11.6055 11.6198C11.7894 11.44 12.0073 11.2986 12.2466 11.2041C12.4858 11.1096 12.7415 11.0639 12.9987 11.0696C13.5032 11.0807 13.9833 11.2889 14.3363 11.6497C14.6892 12.0104 14.8869 12.495 14.887 12.9996C14.8871 13.5043 14.6897 13.989 14.3369 14.3499C13.9842 14.7108 13.5042 14.9193 12.9996 14.9307ZM18.7927 14.9307C18.5356 14.9365 18.2799 14.8909 18.0406 14.7965C17.8013 14.7021 17.5833 14.5609 17.3993 14.3811C17.2154 14.2013 17.0692 13.9866 16.9694 13.7495C16.8696 13.5124 16.8181 13.2578 16.818 13.0006C16.818 12.7434 16.8693 12.4887 16.969 12.2516C17.0687 12.0145 17.2148 11.7997 17.3986 11.6198C17.5825 11.44 17.8004 11.2986 18.0397 11.2041C18.2789 11.1096 18.5346 11.0639 18.7918 11.0696C19.2963 11.0807 19.7764 11.2889 20.1294 11.6497C20.4823 12.0104 20.68 12.495 20.6801 12.9996C20.6802 13.5043 20.4828 13.989 20.13 14.3499C19.7773 14.7108 19.2973 14.9193 18.7927 14.9307Z" fill="white" />
                    </svg>
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                        <form method="POST" onSubmit={handleLogout}>
                            <Menu.Item>
                                {({ active }) => (
                                    <button
                                        type="submit"
                                        className={classNames(
                                            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                            'block w-full text-left px-4 py-2 text-sm'
                                        )}
                                    >
                                        Cerrar Sesión
                                    </button>
                                )}
                            </Menu.Item>
                        </form>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}
